import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    timestamp: String
  }

  connect() {
    this.updateTimestamp()
  }

  updateTimestamp() {
    if (!this.timestampValue) return

    const date = new Date(this.timestampValue)

    // Format time in browser's local timezone
    const timeString = date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    })

    this.element.textContent = timeString
  }
}
